import { isBrowser } from 'browser-or-node';
import ky from 'ky';
import queryString from 'query-string';
/**
 * Represents a service for making OData requests.
 */
export class ODataService {
    _url;
    _pageSize;
    /**
     * Creates a new instance of the ODataService class.
     * @param url The URL of the OData service.
     * @param pageSize The number of items to retrieve per page (default: 250).
     */
    constructor(url, pageSize = 250) {
        this._url = url;
        this._pageSize = pageSize;
    }
    get url() {
        return this._url;
    }
    get pageSize() {
        return this._pageSize;
    }
}
/**
 * Represents an OData query.
 */
export class ODataQuery {
    _query;
    _service;
    _collection;
    /**
     * Creates a new instance of the ODataQuery class.
     * @param service The ODataService instance to use for executing the query.
     * @param collection The name of the collection to query.
     * @param query The OData query string.
     */
    constructor(service, collection, query) {
        this._service = service;
        this._query = query;
        this._collection = collection;
    }
    get service() {
        return this._service;
    }
    get collection() {
        return this._collection;
    }
    get query() {
        return this._query;
    }
    async processRequest(result, initial, skip) {
        if (result.d) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            result.value = result.d;
        }
        initial = initial.concat(result.value);
        if (result.value.length < this.service.pageSize) {
            return initial;
        }
        return this._execute(skip + this.service.pageSize, initial);
    }
    /**
     * Executes the OData query.
     * @param skip The number of items to skip (default: 0).
     * @param initial The initial array to concatenate the results to (default: []).
     * @returns A promise that resolves to the query results.
     */
    async _execute(skip = 0, initial = []) {
        const data = this.query ?? {};
        data['$format'] = 'json';
        data['$top'] = `${this.service.pageSize}`;
        data['$skip'] = `${skip}`;
        const url = `${this.service.url}/${this.collection}`;
        const requestOptions = {
            url,
            data: queryString.stringify(data),
        };
        if (isBrowser) {
            if (url.startsWith('http://')) {
                requestOptions['url'] = url.replace('http://', '///');
            }
            requestOptions['dataType'] = 'jsonp';
            requestOptions['jsonp'] = '$callback';
            return await $.ajax(requestOptions).then((result) => this.processRequest(result, initial, skip));
        }
        requestOptions['dataType'] = 'json';
        return ky.get(requestOptions['url'], { searchParams: requestOptions['data'], timeout: 120000 }).json().then(async (result) => this.processRequest(result, initial, skip));
    }
    /**
     * Executes the OData query.
     * @returns A promise that resolves to the query results.
     */
    async execute() {
        return this._execute();
    }
}
//# sourceMappingURL=odata.js.map